/*
 * @Author: 屈 乐佳 lj.qu@foundtec.com
 * @Date: 2023-11-06 13:38:02
 * @LastEditors: 屈 乐佳 lj.qu@foundtec.com
 * @LastEditTime: 2023-11-07 17:50:19
 * @FilePath: \video-monitor-web\src\static\filetype.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const fileTypeArr: { [x: string]: string } = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".mp3": "audio/mpeg",
  ".m4a": "audio/x-m4a",
  ".mp4": "video/mp4",
  ".wmv": "video/x-ms-wmv",
  ".gif": "image/gif",
  ".mov": "video/quicktime"
};

export const fileType: { [x: string]: { formatter: string; placeholder: string; limit?: number } } = {
  image: {
    formatter: ".png,.jpg,.jpeg",
    placeholder: "支持上传PNG、JPG图片格式（<=10M）",
    limit: 10 * 1024 * 1024
  },
  video: {
    formatter: ".mp4,.mov",
    placeholder: "支持上传MP4视频格式"
  },
  audio: {
    formatter: ".mp3,.m4a",
    placeholder: "支持上传MP3、M4A格式"
  }
};
